/** `expired` n'est jamais stocké : il se déduit de `validUntil` (voir `effectiveQuoteStatus`). */
export const QUOTE_STATUSES = ['draft', 'sent', 'accepted', 'declined', 'superseded', 'invoiced', 'expired'];
export const QUOTE_STATUS_LABELS = {
    draft: 'Brouillon',
    sent: 'Envoyé',
    accepted: 'Accepté',
    declined: 'Refusé',
    superseded: 'Remplacé',
    invoiced: 'Facturé',
    expired: 'Expiré',
};
/** Un devis envoyé dont la validité est dépassée sans réponse est expiré. */
export function effectiveQuoteStatus(stored, validUntil, today) {
    return stored === 'sent' && validUntil < today ? 'expired' : stored;
}
/** Seul un brouillon se modifie : un devis envoyé se révise en nouvelle version. */
export const isQuoteEditable = (status) => status === 'draft';
export const CATALOG_UNITS = ['hour', 'half_day', 'day', 'session', 'unit', 'flat'];
export const CATALOG_UNIT_LABELS = {
    hour: 'heure',
    half_day: 'demi-journée',
    day: 'jour',
    session: 'séance',
    unit: 'unité',
    flat: 'forfait',
};
//# sourceMappingURL=quotes.js.map